import React from 'react';
import { Target, Eye, ExternalLink } from 'lucide-react';
import Footer from '../components/Footer';

const District9 = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-16">
          <span className="text-[#7d5800] font-bold text-sm uppercase tracking-wider">District 9</span>
          <h1 className="text-5xl md:text-6xl font-bold text-[#123f1e] mt-4">
            Community School District 9
          </h1>
        </header>

        {/* Community Image */}
        <div className="mb-12">
          <img
            src="/assets/images/gallery/District9PreK-160.jpg"
            alt="District 9 Pre-K students and staff at a community event"
            className="w-full h-80 object-cover rounded-3xl shadow-xl"
          />
        </div>

        {/* Mission & Vision Cards */}
        <div className="grid lg:grid-cols-2 gap-8 mb-12">
          {/* Mission */}
          <div className="relative bg-white border-2 border-gray-200 rounded-3xl p-10 hover:border-[#febc04] transition-all group">
            <div className="absolute top-0 left-0 w-full h-2 bg-[#123f1e] rounded-t-3xl"></div>
            <div className="flex items-start gap-4 mb-6">
              <div className="p-4 bg-[#123f1e] rounded-2xl text-white">
                <Target className="w-8 h-8" />
              </div>
              <h2 className="text-3xl font-bold text-[#123f1e] mt-2">Our Mission</h2>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">
              Community School District 9 will collaborate with all stakeholders to create supportive, accelerated, and diverse learning experiences and build strong school-community ties for every student and family.
            </p>
            <div className="mt-8">
              <a
                href="https://bronxdistrict9.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2.5 px-6 py-4 bg-[#123f1e] text-white font-semibold rounded-xl hover:bg-[#1a5a2d] transition-all duration-200 shadow-md hover:shadow-lg hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#123f1e] focus:ring-offset-2"
              >
                <span>Visit Bronx District 9 Website</span>
                <ExternalLink className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Vision */}
          <div className="relative bg-white border-2 border-gray-200 rounded-3xl p-10 hover:border-[#febc04] transition-all group">
            <div className="absolute top-0 left-0 w-full h-2 bg-[#febc04] rounded-t-3xl"></div>
            <div className="flex items-start gap-4 mb-6">
              <div className="p-4 bg-[#febc04] rounded-2xl text-[#123f1e]">
                <Eye className="w-8 h-8" />
              </div>
              <h2 className="text-3xl font-bold text-[#123f1e] mt-2">Our Vision</h2>
            </div>
            <p className="text-gray-700 leading-relaxed text-lg">
              Community School District 9 will foster a safe, supportive, and culturally responsive community where every student thrives civically and academically and is college and career ready.
            </p>
          </div>
        </div>

        {/* Image */}
        <div className="mt-12">
          <img
            src="https://goldprekd9.com/wp-content/uploads/2023/08/D9-School-Website-Version-Mission-and-Vision.jpg"
            alt="District 9 Mission and Vision"
            className="w-full rounded-3xl shadow-2xl"
          />
        </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default District9;
